// Migrated from gen widgets/Widget.jsx. Probably should load from theme or something
export const DEFAULT_COLORS = ['#9bb02f', '#4cb6b2', '#c14260']
